import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { LoginAdmin } from '../../models/login/login-admin';
import { catchError, map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { UsuarioLog } from 'src/app/models/login/usuarioLog';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private urlLogin = '/Seguridad/UsuarioPersona';
  private urlPermisos = '/Seguridad/AccionXRol'
  private urlPropiedades = '/Propiedades';
  usuarioGuardar:UsuarioLog  = {
    nombre: '',
    apellido:'',
    num: 0,
    dependencia: '',
    regional: '',
  }
  

  constructor(private http: HttpClient) { }

  setUsuario(usu:UsuarioLog){
    this.usuarioGuardar = usu;
  }
  gettUsuario(){
    return this.usuarioGuardar;
  }
  getPermisos(userId:any): Observable<any> {

      return this.http.post(`${environment.backend.concat(this.urlPermisos).concat("/listarAccionXRolId")}`,userId);

  }
  postLogin(usuario:LoginAdmin): Observable<any>{
    const headers= new HttpHeaders();
    headers.set('content-type', 'application/json')
    return this.http.post(`${environment.backend.concat(this.urlLogin)}/login`,usuario, {'headers':headers}).pipe(catchError(err =>{
      Swal.fire({
        icon: 'error',
        title: 'Problema de conexión ',
        text: 'Pongase en contacto con administrador'
      })
      return err
      
    }));
  }
  pruebaUrl(){
    return this.http.get('http://3.139.144.19:443/Back_MVO/Seguridad/UsuarioPersona/listarUsuarioPersona');
  }
  capturarError(){

  }
  getVideo() {
    return this.http.get(`${environment.backend.concat(this.urlPropiedades).concat("/buscarPropiedad")}`);
   
}
  // getListAllAleatoriedad(): Observable<any> {
  //   return this.http.get(`${environment.backend.concat(this.baseAleatoriedad)}`);
  // }

  // getAleatoriedad(aleatoriedadId: number): Observable<any> {
  //   return this.http.get(`${environment.backend.concat(this.baseAleatoriedad)}/${aleatoriedadId}`);
  // }
}
